// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDateTime,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import momentTimezone from 'moment-timezone';

// Types
import type {
  $ReducerState,
} from '../../../redux';

export type $OwnProps = $Translate & {
  date: string;
  item: $Model<'RegattaProtestEnd'> | $ModelUpsertParams<'RegattaProtestEnd'>;
  resourceData: Array<$Model<'RegattaResultTable'>>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

const RegattaProtestEndFieldsView = function ({
  date,
  item,
  main,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Group')}
            name={'RegattaResultTableId'}
            required
            type={'select'}
            value={item.RegattaResultTableId}
          >
            {item.RegattaResultTableId === '' && (
              <option />
            )}
            {_.map(
              resourceData,
              (i) => (
                <option
                  key={i.id}
                  value={i.id}
                >
                  {i.Name}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col>
          <InputDateTime
            label={t('Protest end time')}
            labelOpenCalendar={t('Open calendar')}
            name={'EndDate'}
            range={{
              max: momentTimezone.tz(
                `${date} 23:59:59`,
                main.timezone,
              ).toDate(),
              min: momentTimezone.tz(
                `${date} 00:00:00`,
                main.timezone,
              ).toDate(),
            }}
            required
            timezone={main.timezone}
            value={item.EndDate}
          />
        </Col>
      </Row>
    </>
  );
};

export default RegattaProtestEndFieldsView;
